import {createRouter,createWebHistory} from 'vue-router';
export const router=createRouter({
  history:createWebHistory(),
  routes:[
    {path:'/',name:'home',component:()=>import('../views/Home/index.vue')},
    {path:'/about-company',name:'about-company',meta:{standalone:true},component:()=>import('../views/AboutCompany/index.vue')},
    {path:'/series/majestic-escapes',redirect:'/series/ruby'},
    {path:'/series/engagement-rings',redirect:'/series/sapphire'},
    {path:'/series/wedding-bands',redirect:'/series/emerald-jewelry'},
    {path:'/series/emerald',redirect:'/series/jadeite'},
    {path:'/series/high-jewelry',redirect:'/series/gemstone-necklaces'},
    {path:'/series/timepieces',redirect:'/series/jadeite-earrings'},
    {path:'/product/sapphire-necklace',redirect:'/product/ruby-halo-necklace'},
    {path:'/product/sapphire-creation',redirect:'/product/sapphire-flower-ring'},
    {path:'/product/cushion-diamond-ring',redirect:'/product/sapphire-oval-ring'},
    {path:'/product/diamond-craft-ring',redirect:'/product/ruby-flower-ring'},
    {path:'/product/diamond-wedding-band',redirect:'/product/emerald-halo-ring'},
    {path:'/product/emerald-timepiece',redirect:'/product/jadeite-double-drop'},
    {path:'/product/cluster-jewelry',redirect:'/product/jadeite-lavender-earrings'},
    {path:'/product/yellow-diamond-necklace',redirect:'/series/ruby'},
    {path:'/product/signature-timepiece',redirect:'/series/jadeite'},
    {path:'/series/:slug',name:'series',component:()=>import('../views/SeriesList/index.vue')},
    {path:'/product/:slug',name:'product',component:()=>import('../views/ProductDetail/index.vue')},
    {path:'/stores',name:'stores',component:()=>import('../views/StoreList/index.vue')},
    {path:'/contact',name:'contact',component:()=>import('../views/Contact/index.vue')},
    {path:'/article/:slug',name:'article',component:()=>import('../views/ArticlePage/index.vue')},
    {path:'/:pathMatch(.*)*',name:'notfound',component:()=>import('../views/NotFound.vue')},
  ],
  scrollBehavior(to,from,saved){if(saved)return saved;if(to.hash&&to.path===from.path)return{el:to.hash,top:140,behavior:'smooth'};if(to.path===from.path)return{};return{top:0,behavior:'instant'};},
});
